/**
 * URL do app Monitor 360 (CRA: REACT_APP_MONITOR360_URL no .env da raiz do Hub).
 */
export function getMonitor360WebUrl() {
  return (
    process.env.REACT_APP_MONITOR360_URL || "https://monitor360-chi.vercel.app/"
  ).replace(/\/$/, "");
}
